const envChannelsLimit = import.meta.env.VITE_CHANNELS_INITIAL_LIMIT;
const parsed =
    envChannelsLimit != null && envChannelsLimit !== "" ? parseInt(String(envChannelsLimit), 10) : NaN;
export const CHANNELS_INITIAL_LIMIT = Number.isFinite(parsed) && parsed > 0 ? parsed : 10;

/** Firestore collection for tutor class chat channels (document id = class_id). */
export const TUTOR_CLASS_CHANNELS_COLLECTION =
    import.meta.env.VITE_FIREBASE_CHAT_CHANNELS_COLLECTION ??
    import.meta.env.VITE_FIREBASE_TUTOR_CLASS_CHANNELS_COLLECTION ??
    "Channels";

/** Messages subcollection name under each channel document. */
export const TUTOR_CHANNEL_MESSAGES_SUBCOLLECTION =
    import.meta.env.VITE_FIREBASE_CHAT_MESSAGES_SUBCOLLECTION ?? "messages";

export const globalConfig = {
    domain: import.meta.env.VITE_Domain ?? "",
    apiURL: import.meta.env.VITE_ApiURL ?? "",
    cdnUrl: import.meta.env.VITE_CDNUrl ?? import.meta.env.VITE_CDN_BASE ?? "",
    googleClientId: import.meta.env.VITE_GoogleClientId ?? "",
    crmDomain: import.meta.env.VITE_CRM_DOMAIN ?? "",
    classesAPI: import.meta.env.VITE_ClassesAPI ?? "",
    firebaseConfig: {
        apiKey: import.meta.env.VITE_FirebaseApiKey ?? import.meta.env.VITE_FIREBASE_API_KEY,
        authDomain: import.meta.env.VITE_FirebaseDomain ?? import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
        projectId: import.meta.env.VITE_FirebaseProjectId ?? import.meta.env.VITE_FIREBASE_PROJECT_ID,
        storageBucket:
            import.meta.env.VITE_FirebaseStorageBucket ?? import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
        messagingSenderId:
            import.meta.env.VITE_FirebaseMessagingSenderId ??
            import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
        appId: import.meta.env.VITE_FirebaseAppId ?? import.meta.env.VITE_FIREBASE_APP_ID,
    },
};
